module.exports = __webpack_public_path__ + "img/optionchain2.67f7bb0f.jpg";